// extracted by mini-css-extract-plugin
export var container = "_4o-0";
export var disabled = "_4o-4";
export var fullWidth = "_4o-3";
export var lined = "_4o-1";
export var selected = "_4o-5";
export var tab = "_4o-2";